import { asText } from '@prismicio/helpers';
import Image from 'next/image';
import { useState } from 'react';
import { PrimaryCTA } from 'remote-com-shared/components/CallToAction';
import { PrimaryCTAButton } from 'remote-com-shared/components/CallToAction/Primary';

import { SimpleFormModal } from './SimpleForm';

import { transformProperties } from '@/src/domains/prismic/helpers';

export function BottomCtaSectionSlice({ slice }) {
  const { primary, context } = transformProperties(slice);
  const {
    ctaLabel,
    label,
    headingTitle,
    description,
    ctaLink,
    tone,
    noIllustration,
    flippedIllustration,
    icon,
  } = primary;

  const [displayModal, setDisplayModal] = useState(false);

  function openModal() {
    setDisplayModal(true);
  }
  function closeModal() {
    setDisplayModal(false);
  }
  return (
    <PrimaryCTA
      label={label}
      title={headingTitle}
      description={asText(description)}
      $noIllustration={noIllustration}
      $flippedIllustration={flippedIllustration}
      tone={tone}
      wideContent
      icon={
        icon ? (
          <Image
            src={icon.url}
            alt={icon.alt || ''}
            width={icon.dimensions.width}
            height={icon.dimensions.height}
            quality="100"
          />
        ) : null
      }
    >
      {ctaLink ? (
        <PrimaryCTAButton href={ctaLink.url} rel="nofollow">
          {ctaLabel}
        </PrimaryCTAButton>
      ) : (
        <PrimaryCTAButton onClick={openModal} rel="nofollow">
          {ctaLabel}
        </PrimaryCTAButton>
      )}

      {!ctaLink && !context && (
        <PrimaryCTAButton
          href={`${process.env.NEXT_PUBLIC_EMPLOY_BASE_URL}/sign-up`}
          rel="nofollow"
        >
          {ctaLabel}
        </PrimaryCTAButton>
      )}
      {context ? (
        <SimpleFormModal
          modalFormTitle={context.formTitle}
          modalFormDescription={context.formDescription}
          modalFormSubmitLabel={context.formButtonLabel}
          eventName={context.eventName}
          hubspotFormDefinition={context.globalHubspotFormDefinition}
          visible={displayModal}
          onCancel={closeModal}
        />
      ) : null}
    </PrimaryCTA>
  );
}
